import React, {useEffect, useRef} from "react";
import {InputBase, makeStyles} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {filterTree} from "../../../reducers/applicationBuilder.slice";

const useStyles = makeStyles(() => ({
    input: {
        padding: 0,
        //pointerEvents: "none",
        '& .MuiInputBase-input': {
            //pointerEvents: "none",
            padding: "0 5px",
            textAlign: "right",
        }
    },
}))

const SearchField = ({searchKey, isInSearch, onChangeInSearch}) => {
    const classes = useStyles();
    const filter = useSelector(state => state.applicationBuilder.filter);
    const dispatch = useDispatch();
    const inputRef = useRef(null);

    useEffect(() => {
        if (isInSearch) {
            inputRef.current.focus();
        }
    }, [isInSearch]);


    return (
        <InputBase
            inputRef={inputRef}
            className={classes.input}
            variant={"outlined"}
            onBlur={onChangeInSearch}
            size="small"
            autoFocus={true}
            value={filter[searchKey]}
            onChange={(e) => {
                dispatch(filterTree({filterString: e.currentTarget.value, key: searchKey}));
            }}
            disabled={!isInSearch}
            style={{
                textAlign: 'right',
                color: isInSearch ? '#000' : '#bebebe',
                pointerEvents: isInSearch ? "auto" : "none"
            }}
            onClick={(e) => {
                if (isInSearch) {
                    e.stopPropagation()
                }
            }}
        />
    )
}
export default SearchField;